export default "__VITE_ASSET__CXIFVA4U__"